import { Grid } from '@material-ui/core'
import styled from 'styled-components'

export const Wrapper = styled(Grid)`
  margin-bottom: 7.4rem;
  gap: 2.5rem;
`

export const GridHeader = styled(Grid)`
  display: inline-flexbox;
  padding: 0.5rem 0 0.7rem 0;
`

export const GridTitle = styled(Grid)`
  display: block;
  padding: 0.5rem 0 1rem 0;
`

export const BoxTitle = styled.p`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 2rem;
  font-weight: 400;
`

export const FullGrid = styled(Grid)`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 5px 25px #0000000d;
  border-radius: 1.2rem;
  padding: 2.4rem;
`

export const GridInformations = styled(Grid)`
  display: flex;
  flex-direction: row;
`

export const BoxInformation = styled(Grid)`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`

export const BoxTextValue = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
`

export const TextTitle = styled.p`
  font-size: 1.4rem;
  font-weight: 400;
  color: #808080;
  flex: 0 0 10rem;
`

export const TextValue = styled.p`
  font-size: 1.4rem;
  font-weight: 600;
  color: #464a53;
`

export const IndustryImage = styled.img`
  flex: 1;
  max-width: fit-content;
  max-height: 30rem;
  border-radius: 1rem;
  object-fit: cover;
  object-position: center;
`

export const BoxIndustryImage = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const GridInputs = styled(Grid)`
  display: flex;
`

export const GridButtons = styled(Grid)`
  align-self: center;
  text-align: end;
  button + button {
    margin-left: 0.8rem;
  }
`

export const GridInput = styled(Grid)``

export const GridFilter = styled(Grid)`
  display: flex;
  margin: 0 -0.8rem;
  width: calc(100% + 16px);
  flex-direction: row;
`

export const BoxTable = styled.div`
  margin-top: 2rem;
`
